import React from 'react';
import Badge from 'src/components/Badge';
import { StreamingSession } from '../state/Sessions';

export interface SessionStatusProps {
  status: StreamingSession['status'];
}

export default function SessionStatus({ status }: SessionStatusProps) {
  return <Badge color={getStatusColor(status)} label={status} />;
}

function getStatusColor(
  status: StreamingSession['status']
): 'success' | 'info' | 'error' | 'warning' | 'default' {
  switch (status) {
    case 'ACTIVE':
      return 'success';
    case 'CONNECTING':
      return 'info';
    case 'IDLE':
      return 'warning';
    case 'STOPPED':
      return 'default';
    default:
      return 'error';
  }
}
